import { render, staticRenderFns } from "./biddingStatusDialog.vue?vue&type=template&id=0d4a54b1&scoped=true"
import script from "./biddingStatusDialog.vue?vue&type=script&lang=js"
export * from "./biddingStatusDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4a54b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d4a54b1')) {
      api.createRecord('0d4a54b1', component.options)
    } else {
      api.reload('0d4a54b1', component.options)
    }
    module.hot.accept("./biddingStatusDialog.vue?vue&type=template&id=0d4a54b1&scoped=true", function () {
      api.rerender('0d4a54b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cardSystem/saleToos/projectDelivery/components/biddingStatusDialog.vue"
export default component.exports